class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    // Pétale Paris : le nom de la couleur suit la pastille survolée, puis revient à la couleur affichée.
    this.addEventListener('mouseover', this.#onOver);
    this.addEventListener('mouseleave', this.#onLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('mouseover', this.#onOver);
    this.removeEventListener('mouseleave', this.#onLeave);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (swatch) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = swatch.dataset.href;
    }
  };

  #onOver = (e) => {
    const swatch = e.target.closest('[data-value]');
    const label = this.querySelector('[data-pp-swatch-label]');
    if (swatch && label) label.textContent = swatch.dataset.value;
  };

  #onLeave = () => {
    const label = this.querySelector('[data-pp-swatch-label]');
    if (label) label.textContent = label.dataset.default;
  };
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}